import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const SpearPhishingAgent = () => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4862 18.8764C10.4862 17.1389 9.0777 15.7305 7.34026 15.7305C5.60282 15.7305 4.19434 17.1389 4.19434 18.8764C4.19434 20.6139 5.60282 22.0223 7.34026 22.0223C9.0777 22.0223 10.4862 20.6139 10.4862 18.8764Z"
      style={{ fill: 'none' }}
      stroke="currentColor"
      strokeWidth="1.625"
    />
    <path
      d="M20.9725 18.8764C20.9725 17.1389 19.5641 15.7305 17.8266 15.7305C16.0891 15.7305 14.6807 17.1389 14.6807 18.8764C14.6807 20.6139 16.0891 22.0223 17.8266 22.0223C19.5641 22.0223 20.9725 20.6139 20.9725 18.8764Z"
      style={{ fill: 'none' }}
      stroke="currentColor"
      strokeWidth="1.625"
    />
    <path
      d="M2.09766 12.582H23.0705"
      style={{ fill: 'none' }}
      stroke="currentColor"
      strokeWidth="1.625"
      strokeLinecap="round"
    />
    <path
      d="M15.2051 17.1368C14.6415 16.2892 13.6778 15.7305 12.5835 15.7305C11.4893 15.7305 10.5256 16.2892 9.96191 17.1368"
      style={{ fill: 'none' }}
      stroke="currentColor"
      strokeWidth="1.625"
      strokeLinecap="round"
    />
    <path
      d="M3.14551 12.5823L4.88799 5.97882C4.98958 5.59386 5.04037 5.40138 5.08943 5.26492C5.80429 3.27634 8.1404 2.51645 9.82832 3.72347C9.94415 3.8063 10.0924 3.93403 10.389 4.18947C10.5593 4.33615 10.6444 4.40949 10.7234 4.46929C11.8306 5.30806 13.336 5.30806 14.4432 4.46929C14.5221 4.40949 14.6073 4.33615 14.7776 4.18947C15.0741 3.93403 15.2224 3.8063 15.3383 3.72347C17.0262 2.51645 19.3622 3.27634 20.0772 5.26492C20.1262 5.40138 20.177 5.59386 20.2785 5.97882L22.0211 12.5823H3.14551Z"
      style={{ fill: 'none' }}
      stroke="currentColor"
      strokeWidth="1.625"
      strokeLinecap="round"
    />
  </svg>
)

export default withDefaultStyles(SpearPhishingAgent)
